export default __webpack_public_path__ + "static/media/xintro.png.pagespeed.ic.wRAmcK6-ty.dec279a6.jpg";